import "./SignUp.scss";

import SignUp from "./SignUp";

export default SignUp;